module.exports = ".mat-selected.mat-option {\n  color: #57c2ec;\n  background-color: #e7f9ff; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/select/select.component.scss
// module id = ./src/app/shared/select/select.component.scss
// module chunks = main